import React from 'react';
import { Link } from 'react-router-dom';
import Hero from '../../components/public/Hero';

const OurApproach = () => {
    const approachPoints = [
        {
            number: '1',
            title: "We Don't Sell Urgency",
            description: "No artificial deadlines. No pressure tactics. No 'act now before it's too late.' Economic stability isn't built under pressure—it's built with patience and understanding."
        },
        {
            number: '2',
            title: "We Don't Promise Quick Results",
            description: "Sustainable change takes time. We provide realistic timelines based on your actual situation, not marketing promises designed to sound appealing."
        },
        {
            number: '3',
            title: "We Don't Push Financial Products",
            description: "Our focus is clarity and systems, not selling specific investment products or insurance policies. Understanding comes first; products follow only if genuinely needed."
        }
    ];

    const principles = [
        {

            title: 'Clarity First',
            description: 'We help you see your complete economic picture clearly before making any decisions.'
        },
        {

            title: 'Build Strong Foundations',
            description: 'We design systems that reduce instability and create lasting economic discipline.'
        },
        {

            title: 'Respect Your Intelligence',
            description: 'We provide guidance that respects your intelligence and circumstances.'
        },
        {

            title: 'Systematic Approach',
            description: 'We create frameworks that help you make informed decisions consistently.'
        }
    ];

    return (
        <div className="our-approach-page">
            <Hero
                title="Our Approach Is Different by Design"
                subtitle="Our Philosophy"
                description="In a world filled with urgent calls to action and promises of quick transformation, Yathartha takes a fundamentally different path"
                backgroundImage="/Philosophy.jpeg"
            />

            {/* Main Approach Section */}
            <section className="approach-intro-section">
                <div className="container">
                    <div className="approach-intro-text">
                        <p>
                            In a world filled with urgent calls to action and promises of quick transformation,
                            <strong> Yathartha</strong> takes a fundamentally different path. Our difference is not accidental—it is intentional and principled.
                        </p>
                    </div>
                </div>
            </section>

            {/* Numbered Points Section */}
            <section className="approach-points-section">
                <div className="container">
                    <div className="approach-points-grid">
                        {approachPoints.map((point, index) => (
                            <div
                                key={index}
                                className="approach-point-card"
                                style={{ animationDelay: `${index * 0.15}s` }}
                            >
                                <div className="point-number-circle">{point.number}</div>
                                <h3>{point.title}</h3>
                                <p>{point.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Instead Section */}
            <section className="instead-section">
                <div className="container">
                    <h2>Instead, We Build Economic Discipline and Clarity</h2>
                    <p className="instead-description">
                        We create frameworks that help you see your complete economic picture clearly.
                        We design systems that reduce instability. We provide guidance that respects your intelligence and circumstances.
                    </p>
                    <div className="stability-note">
                        <strong>Stability follows structure.</strong> When you build proper foundations, lasting results emerge naturally.
                    </div>
                </div>
            </section>

            {/* Principles Grid */}
            {/* <section className="principles-section">
                <div className="container">
                    <div className="section-title">
                        <h2 className="section-heading">Our Core Principles</h2>
                        <p className="section-description">
                            The fundamental beliefs that guide our methodology
                        </p>
                    </div>
                    <div className="principles-grid">
                        {principles.map((principle, index) => (
                            <div
                                key={index}
                                className="principle-card"
                                style={{ animationDelay: `${index * 0.1}s` }}
                            >
                                <div className="principle-icon">{principle.icon}</div>
                                <h3>{principle.title}</h3>
                                <p>{principle.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section> */}
        </div>
    );
};

export default OurApproach;
